import { Component, OnInit } from '@angular/core';
import { EstadoCurso } from 'src/app/models/estado.model';
import { CursosService } from 'src/app/services/cursos.service';
import { User } from 'src/app/models/login';
import { AuthService } from 'src/app/_helpers';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { KeyValueModel } from 'src/app/models/key-value.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  tablaCursos: EstadoCurso[] = [];
  codCurso = '';
  codPersona = '';
  codTemaCapacita = '';
  fecVenc: Date;
  vigenciaOpt: KeyValueModel[] = [];
  constructor(
    private estado: CursosService,
    private authService: AuthService,
    private router: Router

  ) { }
  // 
  ngOnInit() {




    this.codPersona = this.authService.getusuarioJson().codPersona;
    console.log('persona', this.codPersona, this.authService.getusuarioJson());
    this.estado.getEstadoCursos(this.codPersona).subscribe(
      data => {
        console.log('dashboard', data);

        this.tablaCursos = data['data'];
      }, error => {
        console.log('Error', error);
      }
    );

    this.authService.getTabla('VigenciaCapacita').forEach(value => {
      this.vigenciaOpt.push(new KeyValueModel(value.codRegistro, value.descripcion, ''));

    });





  }

  // VerCursosDisponibles(event) {
  //   console.log(event);
  //   this.codTemaCapacita = event.codTemaCapacita;

  //   this.estado.getCursoDisponible(this.codPersona, this.codTemaCapacita).subscribe(
  //     data => {
  //       this.estado.listaDisponible = data['data'];
  //       this.router.navigateByUrl("/CursosDisponibles");

  //     }, error => {
  //       console.log('Error', error);
  //     }
  //   );




  // }



  formatoFecha(fecha: string){
    this.fecVenc = new Date(fecha);
    return moment(this.fecVenc).format('DD/MM/YYYY');
  
  }

  getDesVigencia(code: string) {
    console.log (code, this.vigenciaOpt);
    if (code && code !== '') {
      return this.vigenciaOpt.filter(val => +val.Key === +code)[0].Value;
    } else {
      return null;
    }
  }



}
